import { render, staticRenderFns } from "./LgsReferralGuideEdit.vue?vue&type=template&id=218aaa62"
import script from "./LgsReferralGuideEdit.vue?vue&type=script&lang=js"
export * from "./LgsReferralGuideEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports